import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const EmailVerificationSuccess = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-850 text-white p-4 font-sans antialiased">
      <div className="bg-gray-800 rounded-3xl p-8 md:p-12 shadow-2xl border border-gray-700 text-center max-w-lg w-full">
        <CheckCircle className="text-green-500 w-24 h-24 mx-auto mb-6" />
        <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
          E-posta Adresiniz Doğrulandı!
        </h1>
        <p className="text-gray-400 text-lg mb-8">
          Mekânname'ye hoş geldiniz. Hesabınız başarıyla aktive edildi. Şimdi giriş yapabilir ve keşfetmeye başlayabilirsiniz.
        </p>
        <button
          onClick={handleLoginRedirect}
          className="w-full py-4 px-6 rounded-xl text-lg font-bold text-white
                     bg-gradient-to-r from-blue-600 to-indigo-700
                     hover:from-blue-700 hover:to-indigo-800
                     transform transition-all duration-300
                     hover:scale-105 hover:shadow-2xl"
        >
          Giriş Yap
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationSuccess;
